export default __webpack_public_path__ + "6d637a8428903814e2977eeca31f3d8b.webp";